import * as React from "react";
import { useStyles } from "../../assets/styles/Theme";
import { useTheme } from "@mui/material/styles";
import { Box, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import InfoDisplayGrid from "../common/InfoDisplayGrid";
import { FormatDate } from "../../utils/common/DateUtils";
import { transformPoData } from "../../utils/grn/grnDataUtils";
import { AnyForNow } from "../../features/grn/types";

interface ViewGrnPoProps {
  grnDetailsForm: AnyForNow;
  grnHeader: AnyForNow;
}

const ViewGrnPo: React.FC<ViewGrnPoProps> = (props) => {
  const { grnDetailsForm, grnHeader } = props;
  const theme = useTheme();
  const styles = useStyles(theme);

  const poData = transformPoData(grnDetailsForm, grnHeader);

  const poInfoData = [
    // { label: "GRN Date", value: FormatDate(poData.endate) },
    { label: "PO Number", value: poData.poNumber },
    { label: "PO Date", value: FormatDate(poData.poDate) },
    { label: "Invoice Number", value: poData.invoiceNumber },
    { label: "Invoice Date", value: FormatDate(poData.invoiceDate) },
    { label: "Dispatched Number", value: poData.dispatchNumber },
    { label: "Dispatched Date", value: FormatDate(poData.dispatchDate) },
    { label: "Delivery Note Number", value: poData.deliveryNoteNumber },
    { label: "Delivery Date", value: FormatDate(poData.deliveryDate) },
    { label: "Delivery Location", value: poData.deliveryLocation },
    { label: "Partial Shipments", value: poData.partialShipments },
    { label: "AWB Number", value: poData.awbNumber },
    { label: "Bill of Lading Number", value: poData.billOfLandingNumber },
       // { label: "Serial Number" },
  ];

  return (
    <Grid container spacing={1}>
      <Grid size={{ xs: 12 }}>
        <InfoDisplayGrid data={poInfoData} />
      </Grid>
    </Grid>
  );
};

export default ViewGrnPo;
